export default {
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: true,
    validateDebounceTime: 300,
  },
  message: {
    text: '',
    messageType: '',
  },
  primaryColour: '#B61311',
};
